export const validator = (value) => {
  if (value.length === 0) {
    return "This Field Cannot Be Empty";
  }
  else {
    return;
  }
};